import React, { Component } from 'react'
import TextMessage from './TextMessage'
import EmojiMessage from './EmojiMessage'
import classNames  from 'classnames';
import moment from 'moment';
import { LINE_ITEM_DETAIL_DATE_FORMAT, CHAT_DATE_FORMAT, CHAT_TIME_FORMAT } from '../../../constants/commonConstants';
import { PROVIDER_VALUE } from 'Constants/commonConstants';
import { getUser } from 'Utils/storage';
class Message extends Component {

  _renderMessageOfType(type) {
    switch(type) {
      case 'text':
        return <TextMessage {...this.props.message} />
      case 'emoji':
        return <EmojiMessage {...this.props.message} />
    }
  }

  render () {
    const { message, userId, optionList } = this.props; 
    let who = "you";
    if(message.author == userId) {
      who = "you";
    } else if(message.author != userId && !message.isSeeker) {
      who = "transporter";
    } else if(message.isSeeker) {
      who = "seeker";
    }

    return (
      <div className="sc-message pb-10">
        <div className={classNames("sc-message--content flex flex-column",{
          "sent flex-bottom": who == "you",
          "received": who == "seeker", 
          "received other-transporter": who == "transporter" 
        })}>
          <div className="fs-12 blur-table-text-color pl-5 fBold"> 
          {(PROVIDER_VALUE !== getUser().companyType) ? 
            <span className="wt-max-content">{`From ${message.isSeeker ? `${message.username || 'Me to'}` : ''}`}<span className='green-color'>{((optionList || []).find(el => el.id === (message.toId || message.author)) || {}).name || message.transporter_name}</span></span> 
          : <span className="wt-max-content green-color">{`${message.isSeeker ? 'From Seeker': 'From Me'}`}</span> }
          </div>
          <span className="wt-max-content">
            <TextMessage data={{text: this.props.message.message.toString()}} />
          </span>
          <div className="fs-10 blur-table-text-color pl-5"> 
            <span>{moment(this.props.message.at).format(CHAT_DATE_FORMAT)} at {moment(this.props.message.at).format(CHAT_TIME_FORMAT)} </span>
          </div>
        </div>
      </div>)
  }
}

export default Message